@if(quote) {
<div class="container my-0">
    <!-- Quote Summary -->
    <div class="card mb-3">
        <div class="card-body">
            <div class="d-flex justify-content-between align-items-start flex-wrap">
                <div>
                    <h3 class="card-title mb-1">Quote #{{ quote.number }} </h3>

                    <span class="badge bg-primary text-capitalize">{{ quote.status }}</span>
                    @if (quote.isQuickQuote) {
                    <div class="badge bg-info ms-2">Quick Quote</div>
                    }
                </div>
                <div class="text-end">
                    <div class="small text-muted">Price Type</div>
                    <div class="fw-semibold text-capitalize">{{ quote.priceType }}</div>
                    @if (isEditable(quote) && hasDetailsPermissions()) {
                    <button class="btn btn-sm btn-outline-secondary mt-1"
                        (click)="changePriceType(priceTypeModal, quote)">Change Price Type</button>
                    }
                </div>
            </div>

            <div class="row mt-3">
                <h3>Date</h3>
                <p class="mb-0 fw-semibold">{{ (quote.finalizedDate || quote.creationDate) | utcToLocal }}</p>
            </div>

            <!-- Customer & Sales Rep Info -->
            <div class="row mt-3">
                <div class="col-md-4 mb-3">
                    <h4 class="text-primary">Customer</h4>
                    <p class="mb-0 fw-semibold">{{ quote.customer.name }}</p>
                    @if (quote.customer.pointOfContactName || quote.customer.pointOfContactTitle) {
                    <p class="mb-0">
                        {{ quote.customer.pointOfContactName }}
                        @if (quote.customer.pointOfContactTitle) {
                        <span class="text-muted">&middot; {{ quote.customer.pointOfContactTitle }}</span>
                        }
                    </p>
                    }

                    <p class="mb-0">{{ quote.customer.phone }}</p>
                    <p class="mb-0">{{ quote.customer.email }}</p>
                    <p class="mb-0 text-pre">{{ formatAddressDetails(quote.customer) }}</p>
                </div>
                @if (!quote.useBillingForShipping) {
                <div class="col-md-4 mb-3">
                    <h4 class="text-primary">Shipping Address</h4>
                    <p class="mb-0 fw-semibold">{{ quote.shippingAddress.name }}</p>
                    <p class="mb-0 text-pre">{{ formatAddressDetails(quote.shippingAddress) }}</p>
                </div>
                }
                <div class="col-md-4 mb-3">
                    <h4 class="text-primary">Sales Representative</h4>
                    <p class="mb-0 fw-semibold">{{ quote.salesRepresentative.name }}</p>
                    <p class="mb-0">{{ quote.salesRepresentative.title }}</p>
                    <p class="mb-0">{{ quote.salesRepresentative.email }}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-end mb-3">
        @if (hasDetailsPermissions()) {
        <a class="col-6 col-md-2 btn btn-primary mx-2" [routerLink]="['/', 'quote-update', quote.id]">Update Details</a>
        }
        @if (isEditable(quote))
        {
        <a class="col-4 col-md-3 col-lg-2 btn btn-primary" [routerLink]="['/', 'product-type-select']"
            [queryParams]="{ quoteId: quote.id }">Add
            Item</a>
        }
    </div>
    <!-- Line Items -->
    @for (item of quote.lineItems; track item.productId) {
    <div class="card mb-1 shadow-sm">
        <div class="card-body">
            <div class="row">
                <div class="col-12 col-md-8 col-lg-3">
                    <h6 class="mb-1">{{ item.productName }}</h6>
                    <div class="text-muted small mb-2">SKU: {{ item.sku }}</div>
                    <p class="mb-2 text-pre-wrap" style="white-space: pre;">{{ item.description }}</p>
                    @if(item.salesNote) {
                    <p class="mb-2 fs-6 fw-light fst-italic">Sales Note: {{ item.salesNote }}</p>
                    }
                </div>
                <!-- Image -->
                <div class="col-12 col-md-4 col-lg-3 d-flex justify-content-center">
                    <img [src]="'https://assets.digiamerica.us/images/products/' + item.productCategory + '/' + item.sku + '.webp'"
                        alt="" class="product-image" />
                </div>
                <!-- Pricing Row -->
                <div class="col-12 col-lg-6 row text-end justify-content-end">
                    <!-- Quantity -->
                    <div class="col-4 text-start">
                        <div class="fw-semibold">Qty</div>
                        @if (!isEditable(quote)) {
                        <div>{{ item.quantity }}</div>
                        }
                        @else {
                        <input type="number" class="form-control form-control-sm" [value]="item.quantity"
                            (input)="onQuantityInput($event.target, quote.id, item.productId)"
                            [min]="minimumQuantity(item)" />
                        }
                        @if (minimumQuantity(item) > 1) {
                        <div class="small text-muted">Min. {{ minimumQuantity(item) }}</div>
                        }
                    </div>

                    <!-- Unit Price -->
                    <div class="col-4">
                        <div class="fw-semibold">Unit Price</div>
                        <div>{{ item.unitPrice | currency }}</div>
                    </div>

                    <!-- Extended Price -->
                    <div class="col-4">
                        <div class="fw-semibold">Ext. Price</div>
                        <div>{{ item.extendedPrice | currency }}</div>
                    </div>
                </div>
            </div>
            @if (item.note) {
            <p class="alert alert-info">{{item.note}}</p>
            }
            @if (isEditable(quote)) {

            <!-- Delete Button (Only if editable) -->
            <div class="text-end mt-2">
                @if (hasPriceOverridePermissions()) {
                @if (item.hasPriceOverride) {
                <button class="btn btn-sm btn-outline-danger m-1"
                    (click)="clearPriceOverride(quote.id, item.productId)">Clear Price Override</button>
                }
                @else if(item.unitPrice === 0) {
                <button class="btn btn-sm btn-outline-danger m-1"
                    (click)="priceOverride(priceOverrideModal, quote.id, item.productId)">Price Override</button>
                }
                }

                @if (hasDetailsPermissions()) {
                <button class="btn btn-sm btn-outline-secondary m-1"
                    (click)="lineDetails(lineDetailsModal, quote.id, item)">Edit Details</button>
                }

                <button class="btn btn-sm btn-outline-danger m-1" (click)="onDeleteLineItem(quote.id, item.productId)">
                    Delete
                </button>
            </div>
            }
        </div>
    </div>
    }

    <!-- Totals -->
    <div class="card mt-3">
        <div class="card-body text-end">
            <div><strong>Subtotal:</strong> {{ quote.subTotal | currency }}</div>
            @if (quote.discount > 0) {
            <div><strong>Discount:</strong> {{ -quote.discount | currency }}</div>
            }
            @if(quote.tariffSurcharge > 0) {
            <div><strong>Tariff Surcharge:</strong> {{quote.tariffSurcharge | currency}}</div>
            }
            @if (quote.shipping > 0 && !quote.rollupShipping) {
            <div><strong>Shipping:</strong> {{ quote.shipping | currency }}</div>
            }
            @if (quote.salesTaxTotal > 0) {
            <div><strong>Sales Tax ({{quote.salesTaxPercent}}%):</strong> {{ quote.salesTaxTotal | currency }}</div>
            }
            <hr>
            <div class="fs-5 fw-bold">Total: {{ quote.total | currency }}</div>
        </div>
    </div>

    <!-- /Totals -->
    @if(quote.lineItems.length > 0)
    {
    @if (!quote.valid) {
    <div class="mt-3 alert alert-warning">Quote must have all items priced before it can be finalized.</div>
    }
    <div class="d-flex justify-content-end mt-3">
        @if(isEditable(quote)) {
        <button class="col-4 col-md-3 col-lg-2 btn btn-primary" [disabled]="!quote.valid"
            (click)="finalizeQuote(quote)">Finalize Quote</button>
        }
        @else {
        <a class="col-4 col-md-3 col-lg-2 btn btn-primary" (click)="downloadPdf(quote)">Download PDF</a>
        }
    </div>
    }

    <!-- Sales Team Member Notes, printed on the customer's PDF before the first item -->
    @if (hasDetailsPermissions() || quote.longNote) {
    <div class="card my-3">
        <div class="card-body">
            <h5 class="card-title">Sales Team Member Notes</h5>

            @if (hasDetailsPermissions()) {
            <label for="quote-long-note" class="form-label visually-hidden">Long Note</label>
            <textarea id="quote-long-note" class="form-control" rows="8" [(ngModel)]="longNoteDraft"
                [class.is-invalid]="longNoteTooLong()" placeholder="Notes for the customer"></textarea>
            <div class="d-flex justify-content-between align-items-start mt-1 gap-2">
                <small [class]="longNoteTooLong() ? 'text-danger' : 'text-muted'">
                    Printed on the customer's quote PDF. Fits about {{ longNoteMaxLines }} lines.
                    {{ longNoteDraft.length }}/{{ longNoteMaxLength }} characters, {{ longNoteLineCount() }}/{{ longNoteMaxLines }} lines.
                    @if (longNoteTooLong()) {
                    Text past this may be cut off.
                    }
                </small>
                <button class="btn btn-sm btn-primary flex-shrink-0"
                    [disabled]="!longNoteChanged(quote) || savingLongNote" (click)="saveLongNote(quote)">Save Note</button>
            </div>
            }
            @else if (quote.longNote) {
            <p class="mb-0 text-pre-wrap">{{ quote.longNote }}</p>
            }
        </div>
    </div>
    }
</div>
}
@else {
<app-loading></app-loading>
}

<ng-template #priceOverrideModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Price Override</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(false)"></button>
    </div>
    <div class="modal-body">
        <p>Please enter a new price below:</p>
        <dai-currency-input #newPrice></dai-currency-input>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close(newPrice.value)">Save</button>
    </div>
</ng-template>

<ng-template #lineDetailsModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Edit Line Details</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(false)"></button>
    </div>
    <div class="modal-body">
        <div class="mb-3">
            <label for="note" class="form-label">Note</label>
            <input type="text" class="form-control" id="note" name="note" placeholder="Enter note" maxlength="100"
                [(ngModel)]="selectedLineDetails.salesNote">
        </div>
        <div class="mb-3">
            <label for="hiddenMarkup" class="form-label">Hidden Markup</label>
            <dai-currency-input id="hiddenMarkup" name="hiddenMarkup"
                [(ngModel)]="selectedLineDetails.hiddenUnitMarkup"></dai-currency-input>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close(selectedLineDetails)">Save</button>
    </div>
</ng-template>

<ng-template #priceTypeModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Change Price Type</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(false)"></button>
    </div>
    <div class="modal-body">
        <p>Every line is re-priced with the new price type. Manual price overrides are kept.</p>
        <label for="price-type-select" class="form-label">Price Type</label>
        <select id="price-type-select" class="form-select text-capitalize" [(ngModel)]="selectedPriceType">
            @for (type of priceTypes; track type) {
            <option [value]="type">{{ type }}{{ type === quote?.priceType ? ' (current)' : '' }}</option>
            }
        </select>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss(false)">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="selectedPriceType === quote?.priceType"
            (click)="modal.close(selectedPriceType)">Change</button>
    </div>
</ng-template>